const KEY = "genesis-telemetry-session";
const IDLE_MS = 30 * 60_000;

function newId(): string {
  const bytes = new Uint8Array(12);
  crypto.getRandomValues(bytes);
  const s = btoa(String.fromCharCode(...bytes)).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
  return "s_" + s.slice(0, 16);
}

// A session is one tab's visit: it lives in sessionStorage and ends after thirty
// idle minutes, the same rule product analytics tools use, so "sessions" here
// means what it means everywhere else.
export function getSessionId(storage: Storage = sessionStorage, now: number = Date.now()): string {
  try {
    const raw = storage.getItem(KEY);
    const saved = raw ? (JSON.parse(raw) as { id: string; at: number }) : null;
    const id = saved && now - saved.at < IDLE_MS ? saved.id : newId();
    storage.setItem(KEY, JSON.stringify({ id, at: now }));
    return id;
  } catch {
    return newId();
  }
}

// The current session id without counting this as activity. Background work —
// the API client tagging a polling request — reads it this way, so a tab left
// open still goes idle and its next real use starts a new session.
export function peekSessionId(storage: Storage = sessionStorage, now: number = Date.now()): string | null {
  try {
    const raw = storage.getItem(KEY);
    const saved = raw ? (JSON.parse(raw) as { id: string; at: number }) : null;
    return saved && now - saved.at < IDLE_MS ? saved.id : null;
  } catch {
    return null;
  }
}
